import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React, { forwardRef } from 'react';
import { Text } from '../Text/Text';
import { StyledCarouselSkipLink } from './CarouselSkipLink.styles';

/**
 * A link that's only shown to keyboard users. Allows them to skip all of
 * a `Carousel's` content.
 *
 * @extends Anchor
 * @since 8.71.0
 */
export var CarouselSkipLink = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledCarouselSkipLink, _extends({
    href: "#",
    ref: forwardedRef
  }, rest), /*#__PURE__*/React.createElement(Text, {
    fontColor: "link"
  }, children));
});
CarouselSkipLink.displayName = 'CarouselSkipLink';